import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { getAuthProps } from "../../utils/AuthenticationLibrary";
import SidebarLinkGroup from "./SidebarLinkGroup";
import {
  SidebarAccountManagementIcon,
  SidebarBannerManagementIcon,
  SidebarBookingIcon,
  SidebarCouncilChapterIcon,
  SidebarDashboardIcon,
  SidebarDtsmeIcon,
  SidebarEmailManagementIcon,
  SidebarEventManagementIcon,
  SidebarFieldMaintenanceIcon,
  SidebarFinancialIcon,
  SidebarGoGlobalIcon,
  SidebarMembershipIcon,
  SidebarOvertheCounterIcon,
  SidebarPageManagementIcon,
  SidebarPartnershipsIcon,
  SidebarSLAReportsIcon,
  SidebarResourcesIcon,
  SidebarSGTechTVIcon,
  SidebarWebsiteCMSIcon,
  SidebarCollaborationPortalIcon,
} from "./SidebarIcons";

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const { pathname } = location;

  const trigger = useRef(null);
  const sidebar = useRef(null);

  const storedSidebarExpanded = localStorage.getItem("sidebar-expanded");
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? true : storedSidebarExpanded === "false"
  );

  // Set Role
  const [role, setRoleId] = useState([]);

  useEffect(() => {
    let cookie = getAuthProps();
    const rolesString = cookie && cookie.roleId ? cookie.roleId : "";
    const roleId = rolesString
      .split(",")
      .map((role) => Number(role.trim()))
      .filter((role) => role > 0);
    if (roleId.length > 0) {
      setRoleId(roleId);
    }
  }, []);

  // End Role
  // close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  useEffect(() => {
    localStorage.setItem("sidebar-expanded", sidebarExpanded);
    if (sidebarExpanded) {
      document.querySelector("body").classList.remove("sidebar-expanded");
    } else {
      document.querySelector("body").classList.add("sidebar-expanded");
    }
  }, [sidebarExpanded]);

  return (
    <div className="main-sidebar-sections">
      {/* Sidebar backdrop (mobile only) */}
      <div
        className={`fixed inset-0 bg-white bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 
        ${sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        aria-hidden="true"
      ></div>

      {/* Sidebar */}
      <div
        id="sidebar"
        ref={sidebar}
        className={`flex flex-col absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto 
        lg:translate-x-0 transform 2xl:sidebar-expanded:!w-80 lg:sidebar-expanded:!w-60 2xl:!w-80 lg:w-[15rem] w-[15rem]  shrink-0 
        bg-white border-r transition-all duration-200 ease-in-out ${sidebarOpen ? "translate-x-0" : "translate-x-0"
          }`}
      >
        {/* Expand / collapse button */}
        <div className="2xl:hidden lg:hidden hidden sm:inline-flex justify-end toggle-btn-sec -mt-3">
          <div
            className="py-2 pb-3 "
            onClick={() => setSidebarExpanded(!sidebarExpanded)}
          >
            <img
              className="rotate-180 sidebar-expanded:rotate-0 w-6"
              src="/navbar-toggle.png"
            />
          </div>
        </div>
        {/* Expand / collapse button */}
        {/* Sidebar header */}
        <div className="flex justify-between 2xl:p-[7px] lg:py-[6px] lg:px-[20px] p-[6.5px] border-b ">
          {/* Logo */}
          <NavLink end to="Dashboard" className="block h-[60px] lg:h-[57px] 2xl:h-[87px] w-auto">
            <img src="/logo.png" alt="" />
          </NavLink>
        </div>

        {/* Links */}
        <div className="space-y-8 px-4 pt-3 xl:mt-6 lg:mt-6 mt-0  pb-8 overflow-y-scroll lg:overflow-y-auto no-scrollbar sidebar-menu-list">
          {/* Pages group */}
          <div>
            <ul className="mt-3">
              {/* Normal Menu Start*/}
              <li
                className={`custom-make-menu rounded-sm 2xl:mb-12 lg:mb-[40px] mb-[20px] last:mb-0 ${pathname.includes("dashboard") && "bg-white"
                  }`}
              >
                <NavLink
                  end
                  to="Dashboard"
                  className={`block font-bold theme-text-color hover:hover-active-color truncate transition duration-150 ${pathname.includes("dashboard") && "hover:theme-text-color"
                    }`}
                >
                  <div className="flex menu-icon-img">
                    <SidebarDashboardIcon />
                    <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                      Admin Dashboard
                    </p>
                  </div>
                </NavLink>
              </li>
              {/* Normal Menu  End*/}

              {/*  */}
              {/* Account Management */}
              {role.length > 0 && role.includes(1) ? (
                <>
                  <SidebarLinkGroup
                    activecondition={
                      pathname === "/" || pathname.includes("Resource")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <a
                            href="#0"
                            className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                        ${pathname === "/CreateAdminAccount"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }  
                        ${pathname === "/ViewEditAdminAccount"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }`}
                            onClick={(e) => {
                              e.preventDefault();
                              sidebarExpanded
                                ? handleClick()
                                : setSidebarExpanded(true);
                            }}
                          >
                            <div className="flex menu-icon-img">
                              <SidebarAccountManagementIcon />
                              <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Account Management
                              </p>
                            </div>
                          </a>
                          <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                            <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="CreateAdminAccount"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/CreateAdminAccount"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Create Account
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="ViewEditAdminAccount"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ViewEditAdminAccount"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    View/Edit Account
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                </>
              ) : null}

              {/* Page Management */}
              {role.includes(1) || role.includes(7) ? (
                <>
                  <SidebarLinkGroup
                    activecondition={
                      pathname === "/" || pathname.includes("Resource")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <a
                            href="#0"
                            className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  ${pathname === "/CreatePages"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                              }  ${pathname === "/ViewPages"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }`}
                            onClick={(e) => {
                              e.preventDefault();
                              sidebarExpanded
                                ? handleClick()
                                : setSidebarExpanded(true);
                            }}
                          >
                            <div className="flex items-baseline justify-between">
                              <div className="flex menu-icon-img">
                                <SidebarPageManagementIcon />
                                <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Page Management
                                </p>
                              </div>
                            </div>
                          </a>
                          <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                            <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="CreatePages"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/CreatePages"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Create Pages
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="ViewPages"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ViewPages"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    View Pages
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                </>
              ) : null}

              {/* Membership */}
              {role.length > 0 && (role.includes(1) || role.includes(2)) ? (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/" || pathname.includes("Membership")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                        ${pathname === "/Membership/Pricing"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/Membership/MTOPricing"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                        ${pathname === "/MembershipCampaign"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/Membership/MembershipTaskList"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/Membership/MembershipRenewalDashboard"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/Membership/MTOTaskList"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/Membership/UpgradeChangeRequestTaskList"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/Membership/AuthorityLimit"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/Membership/MembershipFeeApproval"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/ViewCorporateMembers"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/IndividualMembers"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname ===
                              "/Membership/ChapterXCommitteeWorkgroupMapping"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/Membership/NotificationAnnouncement"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        `}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <div className="flex items-baseline justify-between">
                            <div className="flex menu-icon-img">
                              <SidebarMembershipIcon />
                              <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Membership
                              </p>
                            </div>
                          </div>
                        </a>
                        <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                          <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                            {role.includes(1) || role.includes(2) ? (
                              <>
                                <li className=" my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="Membership/Pricing"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/Membership/Pricing"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Membership Pricing
                                    </span>
                                  </NavLink>
                                </li>

                                <li className=" my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="Membership/MTOPricing"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/Membership/MTOPricing"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      MTO Pricing
                                    </span>
                                  </NavLink>
                                </li>

                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="Membership/MembershipTaskList"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname ===
                                      "/Membership/MembershipTaskList"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Membership Task List
                                    </span>
                                  </NavLink>
                                </li>

                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="Membership/MTOTaskList"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/Membership/MTOTaskList"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      MTO Task List
                                    </span>
                                  </NavLink>
                                </li>

                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="Membership/UpgradeChangeRequestTaskList"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname ===
                                      "/Membership/UpgradeChangeRequestTaskList"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Upgrade/Change Request
                                    </span>
                                  </NavLink>
                                </li>

                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="Membership/MembershipRenewalDashboard"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname ===
                                      "/Membership/MembershipRenewalDashboard"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Renewal Dashboard
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}

                            {role.includes(1) || role.includes(2) ? (
                              <>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="/ViewCorporateMembers"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ViewCorporateMembers"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      View Corporate Members
                                    </span>
                                  </NavLink>
                                </li>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="/IndividualMembers"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/IndividualMembers"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      View Individual Members
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}

                            {role.includes(1) || role.includes(2) ? (
                              <>
                                {/* <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="/Membership/ChapterXCommitteeWorkgroupMapping"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname ===
                                      "/Membership/ChapterXCommitteeWorkgroupMapping"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Chapter x Committee Workgroup Mapping
                                    </span>
                                  </NavLink>
                                </li> */}
                              </>
                            ) : null}
                            {role.includes(1) || role.includes(2) ? (
                              <>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="/Membership/NotificationAnnouncement"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname ===
                                      "/Membership/NotificationAnnouncement"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Notification Announcement
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                          </ul>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              ) : null}

              {/* Entry Management */}
              {(role.length > 0 && role.includes(1)) ||
                role.includes(5) ||
                role.includes(6) ? (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/" || pathname.includes("Entry_Management")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={`block font-bold theme-text-color hover:hover-active-color truncate transition duration-150 
                        ${pathname === "/CreateEntry"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/ViewEditEntries"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                        ${pathname === "/MarketingTrackingURL"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/CreateEntry/eventId"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                         ${pathname === "/EventFeedbackQuestion"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                         ${pathname === "/FormQuestionAnswer"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                          ${pathname === "/financial/EventRegistrationApproval"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                            
                        `}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <div className="flex items-baseline justify-between">
                            <div className="flex menu-icon-img">
                              <SidebarEventManagementIcon />
                              <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Entry Management
                              </p>
                            </div>
                          </div>
                        </a>
                        <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                          <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                            <>
                              {role.includes(1) || role.includes(5) ? (
                                <li
                                  className="my-4 last:mb-0"
                                  onClick={() => window.location.reload()}
                                >
                                  <NavLink
                                    end
                                    to="/CreateEntry"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/CreateEntry"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Create Entry
                                    </span>
                                  </NavLink>
                                </li>
                              ) : null}
                              {role.includes(1) || role.includes(5) ? (
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="/ViewEditEntries"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ViewEditEntries" ||
                                      pathname === "/CreateEntry/eventId"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      View/Edit Entry
                                    </span>
                                  </NavLink>
                                </li>
                              ) : null}
                              {role.includes(1) || role.includes(6) ? (
                                <li className="my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/EventRegistrationApproval"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname ===
                                      "/EventRegistrationApproval" ||
                                      pathname ===
                                      "/financial/EventRegistrationApproval"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Event Registration Approval
                                    </span>
                                  </NavLink>
                                </li>
                              ) : null}
                            </>
                            {role.includes(1) || role.includes(6) ? (
                              <li className="mb-5 last:mb-0">
                                <NavLink
                                  end
                                  to="/MarketingTrackingURL"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/MarketingTrackingURL"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Marketing Tracking URL
                                  </span>
                                </NavLink>
                              </li>
                            ) : null}
                            {role.includes(1) || role.includes(6) ? (
                              <>
                                <li
                                  className="my-4 last:mb-0"
                                >
                                  <NavLink
                                    end
                                    to="/EventFeedbackQuestion"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/EventFeedbackQuestion"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Event Feedback Question
                                    </span>
                                  </NavLink>
                                </li>
                                <li
                                  className="my-4 last:mb-0"
                                >
                                  <NavLink
                                    end
                                    to="/FormQuestionAnswer"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/FormQuestionAnswer"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Event Question Answer
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                          </ul>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              ) : null}

              <li
                className={`custom-make-menu rounded-sm 2xl:mb-12 lg:mb-[40px] mb-[20px] last:mb-0 hidden ${pathname.includes("Over-the-Counter") && "bg-white"
                  }`}
              >
                <NavLink
                  end
                  to="/Over-the-Counter"
                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/Over-the-Counter"
                    ? "hover-active-color"
                    : null
                    }`}
                >
                  <div className="flex menu-icon-img">
                    <SidebarOvertheCounterIcon />
                    <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                      Over the Counter
                    </p>
                  </div>
                </NavLink>
              </li>

              <div className="hidden">
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/" ||
                    pathname.includes("Council_Chapter&Committee")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150 
                        ${(pathname === "/" ||
                              pathname.includes("Council_Chapter&Committee")) &&
                            "hover:theme-text-color"
                            }`}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <div className="flex items-baseline justify-between">
                            <div className="flex menu-icon-img">
                              <SidebarCouncilChapterIcon />
                              <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Council, Chapter & Committee
                              </p>
                            </div>
                          </div>
                        </a>
                        <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                          <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                            <li className="my-4 last:mb-0">
                              <NavLink
                                end
                                to="/Council_Chapter&Committee/Create"
                                className={({ isActive }) =>
                                  "block theme-text-color hover:theme-text-color transition duration-150 truncate " +
                                  (isActive ? "!hover-active-color" : "")
                                }
                              >
                                <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Create
                                </span>
                              </NavLink>
                            </li>
                            <li className="mb-5 last:mb-0">
                              <NavLink
                                end
                                to="/Council_Chapter&Committee/Manage Exco"
                                className={({ isActive }) =>
                                  "block theme-text-color hover:theme-text-color transition duration-150 truncate " +
                                  (isActive ? "!hover-active-color" : "")
                                }
                              >
                                <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Manage Exco
                                </span>
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              </div>

              {/* Financial */}
              {role.length > 0 && (role.includes(1) || role.includes(3)) ? (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/" || pathname.includes("Financial")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                        ${pathname === "/financial/Accountpayable"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/financial/ViewBookingDetail"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/financial/GlobalSettingFinance"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/ChartsOfAccounts"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/PaymentReconciliation"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/CreditNoteApprovalProcess"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/CreditNoteManagement"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/BatchJobExtraction"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                            ${pathname === "/financial/QuickBooksExtraction"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/CreditNoteApproval"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/AddEditExternalInvoice"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/ExternalInvoices"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                            ${pathname === "/financial/ExtractInvoices"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/AddEditExternalInvoice"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/PaymentReconciliation"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/VoucherCodeManagement"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/CreateVoucherCode"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                            ${pathname === "/financial/MembershipReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                            ${pathname === "/financial/VoucherCodeReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                            ${pathname === "/financial/TransactionReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                            ${pathname === "/financial/OrganisationRoleReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                            ${pathname === "/financial/DeferredIncomeReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                            ${pathname === "/dtsme/DTSMEPurchaseReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                             ${pathname === "financial/VoucherCodeReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                            ${pathname === "/financial/ARAgingReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                            ${pathname === "/financial/GSTReport"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        `}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <div className="flex items-baseline justify-between">
                            <div className="flex menu-icon-img">
                              <SidebarFinancialIcon />
                              <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Financial
                              </p>
                            </div>
                          </div>
                        </a>
                        <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                          <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                            {role.includes(1) || role.includes(3) ? (
                              <>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/QuickBooksExtraction"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/QuickBooksExtraction" ||
                                      pathname ===
                                      "/financial/QuickBooksExtraction"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      QuickBooks Finance Data Extraction
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                            {role.includes(1) || role.includes(3) ? (
                              <>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/CreditNoteApproval"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/CreditNoteApproval" ||
                                      pathname ===
                                      "/financial/CreditNoteManagement"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Credit Note
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                            {role.includes(1) || role.includes(3) ? (
                              <>
                                <li className="my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/ExternalInvoices"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ExternalInvoices" ||
                                      pathname ===
                                      "/financial/AddEditExternalInvoice"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      External Invoices
                                    </span>
                                  </NavLink>
                                </li>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/ExtractInvoices"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ExtractInvoices" ||
                                      pathname === "/financial/ExtractInvoices"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Extract Invoices
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                            {role.includes(1) || role.includes(3) ? (
                              <>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/GlobalSettingFinance"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/GlobalSettingFinance"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Global Setting Finance
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                            {role.includes(1) || role.includes(3) ? (
                              <>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/PaymentReconciliation"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/PaymentReconciliation"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Payment Reconciliation
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                            {role.includes(1) || role.includes(3) ? (
                              <>
                                <li className="my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/VoucherCodeManagement"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/VoucherCodeManagement" ||
                                      pathname === "/CreateVoucherCode"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Voucher Code Management
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}

                            {/* voucher report start */}
                            {role.includes(1) || role.includes(3) ? (
                              <>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/VoucherCodeReport"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/VoucherCodeReport" ||
                                      pathname ===
                                      "/financial/VoucherCodeReport"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Voucher Code Report
                                    </span>
                                  </NavLink>
                                </li>

                                {/* voucher report end */}
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/ARAgingReport"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ARAgingReport" ||
                                      pathname === "/financial/ARAgingReport"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      AR Aging Report
                                    </span>
                                  </NavLink>
                                </li>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/GSTReport"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/GSTReport" ||
                                      pathname === "/financial/GSTReport"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      GST Report
                                    </span>
                                  </NavLink>
                                </li>
                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/TransactionReport"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/TransactionReport" ||
                                      pathname ===
                                      "/financial/TransactionReport"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Transaction Report
                                    </span>
                                  </NavLink>
                                </li>

                                <li className="mb-5 last:mb-0">
                                  <NavLink
                                    end
                                    to="financial/DeferredIncomeReport"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/DeferredIncomeReport" ||
                                      pathname ===
                                      "/financial/DeferredIncomeReport"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Deferred Income Report
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                          </ul>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              ) : null}
              {role.length > 0 && (role.includes(1) || role.includes(7)) ? (
                <>
                  <SidebarLinkGroup
                    activecondition={
                      pathname === "/" || pathname.includes("Website-CMS")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <a
                            className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                            ${pathname === "/ManageLeadershipPosition"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/ManageFeaturedNewMembers"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/OrganisationChart"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/ManageSpotlights"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/ManageCommitteeMembers"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/ManageSecretariatDetails"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/ManageCouncilDetails"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            `}
                            onClick={(e) => {
                              e.preventDefault();
                              sidebarExpanded
                                ? handleClick()
                                : setSidebarExpanded(true);
                            }}
                          >
                            <div className="flex items-baseline justify-between">
                              <div className="flex menu-icon-img">
                              <SidebarWebsiteCMSIcon/>
                                <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Website CMS
                                </p>
                              </div>
                            </div>
                          </a>
                          <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                            <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/ManageFeaturedNewMembers"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ManageFeaturedNewMembers"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Manage Featured New Members
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/ManageSpotlights"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ManageSpotlights"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Manage Spotlight
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/ManageCouncilDetails"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ManageCouncilDetails"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Manage Council Members
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/OrganisationChart"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/OrganisationChart"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Manage Organisation Chart
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/ManageCommitteeMembers"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ManageCommitteeMembers"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Manage Committee Members
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/ManageSecretariatDetails"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ManageSecretariatDetails"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Manage Secretariat Members
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                </>
              ) : null}

              {/* Resource */}
              {role.length > 0 && (role.includes(1) || role.includes(7)) ? (
                <>
                  <SidebarLinkGroup
                    activecondition={
                      pathname === "/" || pathname.includes("Resource")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <a
                            href="#0"
                            className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                        ${pathname === "/ViewResource"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                        ${pathname === "/CreatePreviewResource"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }`}
                            onClick={(e) => {
                              e.preventDefault();
                              sidebarExpanded
                                ? handleClick()
                                : setSidebarExpanded(true);
                            }}
                          >
                            <div className="flex items-baseline justify-between">
                              <div className="flex menu-icon-img">
                                <SidebarResourcesIcon />
                                <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Resources
                                </p>
                              </div>
                            </div>
                          </a>
                          <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                            <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/ViewResource"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ViewResource"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    View Resources
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/CreatePreviewResource"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/CreatePreviewResource"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Create Resources
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                </>
              ) : null}

              {role.length > 0 && role.includes(1) ? (
                <>
                  <SidebarLinkGroup
                    activecondition={
                      pathname === "/" || pathname.includes("BannerUpload")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <a
                            href="#0"
                            className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                        ${pathname === "/bannerUpload/chapterscommittee"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                        ${pathname === "/bannerUpload/events"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                        ${pathname === "/bannerUpload/businessopportunities"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                        ${pathname === "/bannerUpload/articles"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }  
                        `}
                            onClick={(e) => {
                              e.preventDefault();
                              sidebarExpanded
                                ? handleClick()
                                : setSidebarExpanded(true);
                            }}
                          >
                            <div className="flex items-baseline justify-between">
                              <div className="flex menu-icon-img">
                                <SidebarBannerManagementIcon />
                                <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Banner Management
                                </p>
                              </div>
                            </div>
                          </a>
                          <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                            <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                              {/* <li
                                className="my-4 last:mb-0"
                                onClick={() => window.location.reload()}
                              >
                                <NavLink
                                  end
                                  to="/bannerUpload/chapterscommittee"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname ===
                                    "/bannerUpload/chapterscommittee"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Chapters/Committee
                                  </span>
                                </NavLink>
                              </li> */}
                              <li
                                className="my-4 last:mb-0"
                                onClick={() => window.location.reload()}
                              >
                                <NavLink
                                  end
                                  to="/bannerUpload/events"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/bannerUpload/events"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Events
                                  </span>
                                </NavLink>
                              </li>
                              <li
                                className="my-4 last:mb-0"
                                onClick={() => window.location.reload()}
                              >
                                <NavLink
                                  end
                                  to="/bannerUpload/businessopportunities"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname ===
                                    "/bannerUpload/businessopportunities"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Business Opportunities
                                  </span>
                                </NavLink>
                              </li>
                              <li
                                className="my-4 last:mb-0"
                                onClick={() => window.location.reload()}
                              >
                                <NavLink
                                  end
                                  to="/bannerUpload/articles"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/bannerUpload/articles"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Articles
                                  </span>
                                </NavLink>
                              </li>
                              <li
                                className="my-4 last:mb-0"
                                onClick={() => window.location.reload()}
                              >
                                <NavLink
                                  end
                                  to="/bannerUpload/home"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/bannerUpload/home"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Home
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                </>
              ) : null}
              {/* Field_Management */}
              {role.length > 0 && role.includes(1) ? (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/" || pathname.includes("Field_Management")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                        ${pathname === "/DropdownManagement"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/EmailTemplateManagement"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                        ${pathname === "/ManageTags"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                      `}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <div className="flex items-baseline justify-between">
                            <div className="flex menu-icon-img">
                              <SidebarFieldMaintenanceIcon />
                              <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Field Maintenance
                              </p>
                            </div>
                          </div>
                        </a>
                        <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                          <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                            {role.length > 0 && role.includes(1) ? (
                              <>
                                <li className="my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="/DropdownManagement"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/DropdownManagement"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Dropdown Management
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                            {role.length > 0 && role.includes(1) ? (
                              <>
                                <li className="my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="/ManageTags"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ManageTags"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Manage Tags
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                            {role.length > 0 && role.includes(1) ? (
                              <>
                                <li className="my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="/EmailTemplateManagement"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/EmailTemplateManagement"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      Email Template Management
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                          </ul>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              ) : null}
              <div className="hidden">
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/" || pathname.includes("Field_Management")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  ${pathname === "/EmailHistory"
                            ? "active hover-active-color"
                            : "hover:theme-text-color"
                            }  ${pathname === "/CreateEmail"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }`}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <div className="flex items-baseline justify-between">
                            <div className="flex menu-icon-img">
                              <SidebarEmailManagementIcon />
                              <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Email Management
                              </p>
                            </div>
                          </div>
                        </a>
                        <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                          <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                            <li className="my-4 last:mb-0">
                              <NavLink
                                end
                                to="/EmailHistory"
                                className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/EmailHistory"
                                  ? "hover-active-color"
                                  : null
                                  }`}
                              >
                                <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Email History
                                </span>
                              </NavLink>
                            </li>
                            <li className="my-4 last:mb-0">
                              <NavLink
                                end
                                to="/CreateEmail"
                                className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/CreateEmail"
                                  ? "hover-active-color"
                                  : null
                                  }`}
                              >
                                <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Create Email
                                </span>
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              </div>

              {/* Booking */}
              {role.length > 0 && role.includes(1) ? (
                <SidebarLinkGroup
                  activecondition={
                    pathname === "/" || pathname.includes("Field_Management")
                  }
                >
                  {(handleClick, open) => {
                    return (
                      <React.Fragment>
                        <a
                          href="#0"
                          className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                        ${pathname === "/booking/ViewNewBookings"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }
                        ${pathname === "/booking/ViewBookingCancellation"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            } 
                        ${pathname === "/financial/ViewBookingDetail"
                              ? "active hover-active-color"
                              : "hover:theme-text-color"
                            }  
                        
                      `}
                          onClick={(e) => {
                            e.preventDefault();
                            sidebarExpanded
                              ? handleClick()
                              : setSidebarExpanded(true);
                          }}
                        >
                          <div className="flex items-baseline justify-between">
                            <div className="flex menu-icon-img">
                              <SidebarBookingIcon />
                              <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                Booking
                              </p>
                            </div>
                          </div>
                        </a>
                        <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                          <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                            {role.length > 0 && role.includes(1) ? (
                              <>
                                <li className="my-4 last:mb-0">
                                  <NavLink
                                    end
                                    to="booking/ViewNewBookings"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/booking/ViewNewBookings" ||
                                      pathname ===
                                      "/financial/ViewBookingDetail"
                                      ? "hover-active-color"
                                      : null
                                      }`}
                                  >
                                    <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                      View New Bookings
                                    </span>
                                  </NavLink>
                                </li>
                              </>
                            ) : null}
                          </ul>
                        </div>
                      </React.Fragment>
                    );
                  }}
                </SidebarLinkGroup>
              ) : null}

              {/* SLA Reports */}
              {role.length > 0 && (role.includes(1) || role.includes(2) || role.includes(7)) ? (
                <>
                  <SidebarLinkGroup
                    activecondition={
                      pathname === "/" || pathname.includes("SLA-Reports")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <a
                            className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                            ${pathname === "/MembershipTrackingReport"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/AllMemberReport"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/EngagementReport"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            ${pathname === "/MembershipReport"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            `}
                            onClick={(e) => {
                              e.preventDefault();
                              sidebarExpanded
                                ? handleClick()
                                : setSidebarExpanded(true);
                            }}
                          >
                            <div className="flex items-baseline justify-between">
                              <div className="flex menu-icon-img">
                                <SidebarSLAReportsIcon />
                                <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  SLA Reports
                                </p>
                              </div>
                            </div>
                          </a>
                          <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                            <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/MembershipTrackingReport"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/MembershipTrackingReport"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Membership Tracking Report
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/AllMemberReport"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/AllMemberReport"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    All Member Report
                                  </span>
                                </NavLink>
                              </li>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/EngagementReport"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/EngagementReport"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Engagement Report
                                  </span>
                                </NavLink>
                              </li>
                              {/* Membership Reports*/}
                              {role.length > 0 && (role.includes(1) || role.includes(2)) ? (
                                <li
                                  className={`custom-make-menu rounded-sm 2xl:mb-12 lg:mb-[40px] mb-[20px] last:mb-0 ${pathname.includes("MembershipReport") && "bg-white"
                                    }`}
                                >
                                  <NavLink
                                    end
                                    to="/MembershipReport"
                                    className={`block theme-text-color hover:theme-text-color transition duration-150 truncate ${pathname.includes("MembershipReport") &&
                                      "hover:theme-text-color"
                                      }`}
                                  >
                                    <div className="flex menu-icon-img">
                                      <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                        Membership Contact Information
                                      </span>
                                    </div>
                                  </NavLink>
                                </li>
                              ) : null}

                            </ul>
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                </>
              ) : null}

              {/* Collaboration Portal */}
              {role.length > 0 && (role.includes(1) || role.includes(7)) ? (
                <>
                  <SidebarLinkGroup
                    activecondition={
                      pathname === "/" || pathname.includes("ViewPosting")
                    }
                  >
                    {(handleClick, open) => {
                      return (
                        <React.Fragment>
                          <a
                            className={` block font-bold theme-text-color hover:hover-active-color truncate transition duration-150  
                            ${pathname === "/ViewPosting"
                                ? "active hover-active-color"
                                : "hover:theme-text-color"
                              }
                            `}
                            onClick={(e) => {
                              e.preventDefault();
                              sidebarExpanded
                                ? handleClick()
                                : setSidebarExpanded(true);
                            }}
                          >
                            <div className="flex items-baseline justify-between">
                              <div className="flex menu-icon-img">
                               <SidebarCollaborationPortalIcon/>
                                <p className="menu-title text-xl ml-2 font-medium  lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                  Collaboration Portal
                                </p>
                              </div>
                            </div>
                          </a>
                          <div className="lg:block lg:sidebar-expanded:block 2xl:block block">
                            <ul className={`pl-9 mt-1 ${!open && "hidden"}`}>
                              <li className="my-4 last:mb-0">
                                <NavLink
                                  end
                                  to="/ViewPosting"
                                  className={`block theme-text-color hover:theme-text-color transition duration-150 truncate  ${pathname === "/ViewPosting"
                                    ? "hover-active-color"
                                    : null
                                    }`}
                                >
                                  <span className="sub-menu-title font-medium lg:opacity-1 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    View Posting
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </React.Fragment>
                      );
                    }}
                  </SidebarLinkGroup>
                </>
              ) : null}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
